var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]},[_c('div',{ref:"overlayContainer"},[_vm._t("default",null,null,_vm.contentData)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }